export function sortArrayByArray(arr: any[], sortingArr: any[]) {
  return arr.sort((a, b) => sortingArr.indexOf(a) - sortingArr.indexOf(b))
}

export function deleteFromArrayStart<T>(
  arr: T[],
  count: number,
  shouldIgnore?: (v: T) => boolean,
) {
  let deletedCount = 0
  const lastDeleteIndex = arr.findIndex(v => {
    if (!shouldIgnore?.(v)) deletedCount += 1
    return deletedCount === count
  })
  return arr.slice(lastDeleteIndex + 1)
}

export function deleteFromArrayEnd<T>(
  arr: T[],
  count: number,
  shouldIgnore?: (v: T) => boolean,
) {
  let deletedCount = 0
  const firstDeleteIndex = findLastIndex(arr, v => {
    if (!shouldIgnore?.(v)) deletedCount += 1
    return deletedCount === count
  })
  return arr.slice(0, firstDeleteIndex)
}

export function findLast<T>(
  array: Array<T>,
  predicate: (value: T, index: number, obj: T[]) => boolean,
): T | undefined {
  let cursor = array.length

  while (cursor) {
    cursor -= 1
    if (predicate(array[cursor], cursor, array)) {
      return array[cursor]
    }
  }

  return undefined
}

export function findLastIndex<T>(
  array: Array<T>,
  predicate: (value: T, index: number, obj: T[]) => boolean,
): number {
  let cursor = array.length

  while (cursor) {
    cursor -= 1
    if (predicate(array[cursor], cursor, array)) {
      return cursor
    }
  }

  return -1
}
